export default __webpack_public_path__ + "static/media/scroll-to-top.4bc29285.svg";